import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

import { downloadDocumentExport } from "@/api/documents/documents";
import { downloadBlob, XLSX_MIME } from "@/utils/download-blob";

/**
 * GET the admin document-export xlsx, trigger a browser download, toast
 * success/error. Callers must guard double-fire with
 * `disabled={mutation.isPending}` because `useMutation` does not dedupe.
 */
export function useDownloadDocumentExportMutation() {
    return useMutation({
        mutationFn: (documentId: number) => downloadDocumentExport(documentId),
        onSuccess: ({ blob, filename }) => {
            downloadBlob(blob, filename, XLSX_MIME);
            toast.success("Document export workbook downloaded");
        },
        onError: () => {
            toast.error("Could not download document export workbook");
        },
    });
}
